"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BerryFlavors = exports.BerryFirmnesses = exports.Berries = void 0;
/** Enum of Berries (NAME - ID) */
var Berries;
(function (Berries) {
    Berries[Berries["CHERI"] = 1] = "CHERI";
    Berries[Berries["CHESTO"] = 2] = "CHESTO";
    Berries[Berries["PECHA"] = 3] = "PECHA";
    Berries[Berries["RAWST"] = 4] = "RAWST";
    Berries[Berries["ASPEAR"] = 5] = "ASPEAR";
    Berries[Berries["LEPPA"] = 6] = "LEPPA";
    Berries[Berries["ORAN"] = 7] = "ORAN";
    Berries[Berries["PERSIM"] = 8] = "PERSIM";
    Berries[Berries["LUM"] = 9] = "LUM";
    Berries[Berries["SITRUS"] = 10] = "SITRUS";
    Berries[Berries["FIGY"] = 11] = "FIGY";
    Berries[Berries["WIKI"] = 12] = "WIKI";
    Berries[Berries["MAGO"] = 13] = "MAGO";
    Berries[Berries["AGUAV"] = 14] = "AGUAV";
    Berries[Berries["IAPAPA"] = 15] = "IAPAPA";
    Berries[Berries["RAZZ"] = 16] = "RAZZ";
    Berries[Berries["BLUK"] = 17] = "BLUK";
    Berries[Berries["NANAB"] = 18] = "NANAB";
    Berries[Berries["WEPEAR"] = 19] = "WEPEAR";
    Berries[Berries["PINAP"] = 20] = "PINAP";
    Berries[Berries["POMEG"] = 21] = "POMEG";
    Berries[Berries["KELPSY"] = 22] = "KELPSY";
    Berries[Berries["QUALOT"] = 23] = "QUALOT";
    Berries[Berries["HONDEW"] = 24] = "HONDEW";
    Berries[Berries["GREPA"] = 25] = "GREPA";
    Berries[Berries["TAMATO"] = 26] = "TAMATO";
    Berries[Berries["CORNN"] = 27] = "CORNN";
    Berries[Berries["MAGOST"] = 28] = "MAGOST";
    Berries[Berries["RABUTA"] = 29] = "RABUTA";
    Berries[Berries["NOMEL"] = 30] = "NOMEL";
    Berries[Berries["SPELON"] = 31] = "SPELON";
    Berries[Berries["PAMTRE"] = 32] = "PAMTRE";
    Berries[Berries["WATMEL"] = 33] = "WATMEL";
    Berries[Berries["DURIN"] = 34] = "DURIN";
    Berries[Berries["BELUE"] = 35] = "BELUE";
    Berries[Berries["OCCA"] = 36] = "OCCA";
    Berries[Berries["PASSHO"] = 37] = "PASSHO";
    Berries[Berries["WACAN"] = 38] = "WACAN";
    Berries[Berries["RINDO"] = 39] = "RINDO";
    Berries[Berries["YACHE"] = 40] = "YACHE";
    Berries[Berries["CHOPLE"] = 41] = "CHOPLE";
    Berries[Berries["KEBIA"] = 42] = "KEBIA";
    Berries[Berries["SHUCA"] = 43] = "SHUCA";
    Berries[Berries["COBA"] = 44] = "COBA";
    Berries[Berries["PAYAPA"] = 45] = "PAYAPA";
    Berries[Berries["TANGA"] = 46] = "TANGA";
    Berries[Berries["CHARTI"] = 47] = "CHARTI";
    Berries[Berries["KASIB"] = 48] = "KASIB";
    Berries[Berries["HABAN"] = 49] = "HABAN";
    Berries[Berries["COLBUR"] = 50] = "COLBUR";
    Berries[Berries["BABIRI"] = 51] = "BABIRI";
    Berries[Berries["CHILAN"] = 52] = "CHILAN";
    Berries[Berries["LIECHI"] = 53] = "LIECHI";
    Berries[Berries["GANLON"] = 54] = "GANLON";
    Berries[Berries["SALAC"] = 55] = "SALAC";
    Berries[Berries["PETAYA"] = 56] = "PETAYA";
    Berries[Berries["APICOT"] = 57] = "APICOT";
    Berries[Berries["LANSAT"] = 58] = "LANSAT";
    Berries[Berries["STARF"] = 59] = "STARF";
    Berries[Berries["ENIGMA"] = 60] = "ENIGMA";
    Berries[Berries["MICLE"] = 61] = "MICLE";
    Berries[Berries["CUSTAP"] = 62] = "CUSTAP";
    Berries[Berries["JABOCA"] = 63] = "JABOCA";
    Berries[Berries["ROWAP"] = 64] = "ROWAP";
})(Berries = exports.Berries || (exports.Berries = {}));
/** Enum of Berry Firmnesses (NAME - ID) */
var BerryFirmnesses;
(function (BerryFirmnesses) {
    BerryFirmnesses[BerryFirmnesses["VERY_SOFT"] = 1] = "VERY_SOFT";
    BerryFirmnesses[BerryFirmnesses["SOFT"] = 2] = "SOFT";
    BerryFirmnesses[BerryFirmnesses["HARD"] = 3] = "HARD";
    BerryFirmnesses[BerryFirmnesses["VERY_HARD"] = 4] = "VERY_HARD";
    BerryFirmnesses[BerryFirmnesses["SUPER_HARD"] = 5] = "SUPER_HARD";
})(BerryFirmnesses = exports.BerryFirmnesses || (exports.BerryFirmnesses = {}));
var BerryFlavors;
(function (BerryFlavors) {
    BerryFlavors[BerryFlavors["SPICY"] = 1] = "SPICY";
    BerryFlavors[BerryFlavors["DRY"] = 2] = "DRY";
    BerryFlavors[BerryFlavors["SWEET"] = 3] = "SWEET";
    BerryFlavors[BerryFlavors["BITTER"] = 4] = "BITTER";
    BerryFlavors[BerryFlavors["SOUR"] = 5] = "SOUR";
})(BerryFlavors = exports.BerryFlavors || (exports.BerryFlavors = {}));
